import { LegalClientKnowledgeAndExperienceEntity } from 'api/types/entity';
import { yesOrNot } from 'helpers';
import { TFunc } from 'libs/i18n';

import { KnowledgeAndExperienceFormType } from '../../forms/knowledgeAndExperienceForm';

export const getInitialData = (
  t: TFunc,
  data: LegalClientKnowledgeAndExperienceEntity | undefined
) => {
  const values: KnowledgeAndExperienceFormType | undefined = data
    ? {
        educationLevel: data.educationLevel
          ? {
              label: t(
                `onboarding.knowledgeAndExperience.education.types.${data.educationLevel}`
              ),
              value: data.educationLevel,
            }
          : undefined,

        financialInstruments: data.financialInstruments?.map((v) => ({
          label: t(
            `onboarding.legalKnowledgeAndExperience.financialInstruments.types.${v}`
          ),
          value: v,
        })),

        hasQualifiedOfficersForInvestmentDecisions: yesOrNot(
          t,
          data.hasQualifiedOfficersForInvestmentDecisions
        ),
        heldFinancialPositionInLast5Years: yesOrNot(
          t,
          data.heldFinancialPositionInLast5Years
        ),
        otherFinancialInstrument: data.otherFinancialInstrument,
      }
    : undefined;

  return values;
};
